import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Localbushireinpune() {



  const cardData =
  {
    keyword: 'Local Bus Hire In Pune ',
    heading: 'Sanavi Travels: Local Bus Hire In Pune',
    headingDescription: 'Sanavi Travels offers reliable Local Bus Hire in Pune, providing safe, comfortable, and affordable transportation for city tours, corporate travel, school trips, weddings, events, picnics, and group outings. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures smooth rides, spacious seating, and ample luggage space for hassle-free local travel across Pune and nearby areas. With professional drivers, flexible hourly and daily rental packages, transparent pricing, and 24/7 booking support, local bus hire services in Pune are ideal for convenient and punctual group transportation. Choose Sanavi Travels for trusted local bus rental services in Pune, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,





"services": [
{
"name": "Local Bus Hire In Pune",
"description": "Local Bus Hire In Pune offers dependable and comfortable bus services for short-distance travel within the city. Ideal for daily commuting, local sightseeing, events, and group travel, these buses ensure timely service, safe journeys, and convenient city transportation."
},
{
"name": "Local Bus Rental Pune",
"description": "Local Bus Rental Pune provides flexible bus rental solutions for city travel needs. With well-maintained buses and professional drivers, this service is suitable for corporate travel, family functions, tours, and local group movements across Pune."
},
{
"name": "AC Local Bus Pune",
"description": "AC Local Bus Pune ensures a cool, comfortable, and pleasant travel experience within the city. These air-conditioned buses are ideal for corporate staff transport, events, and family outings, especially during hot weather conditions."
},
{
"name": "Luxury Local Bus Rental Pune",
"description": "Luxury Local Bus Rental Pune offers premium buses with plush seating, modern interiors, and superior comfort. Perfect for VIP travel, weddings, corporate guests, and special city events requiring a high-end travel experience."
},
{
"name": "Corporate Local Bus Pune",
"description": "Corporate Local Bus Pune is designed for office staff transport, meetings, conferences, and business events within the city. Reliable scheduling, professional chauffeurs, and comfortable buses make corporate commuting smooth and efficient."
},
{
"name": "Wedding Local Bus Pune",
"description": "Wedding Local Bus Pune provides organized and comfortable transportation for guests during wedding ceremonies and functions. Spacious seating and timely service ensure smooth guest movement between venues in Pune."
},
{
"name": "Affordable Local Bus Pune",
"description": "Affordable Local Bus Pune offers budget-friendly bus rental options without compromising on safety or comfort. Ideal for families, students, and groups seeking economical solutions for local travel and city events."
},
{
"name": "Chauffeur Driven Local Bus",
"description": "Chauffeur Driven Local Bus ensures stress-free city travel with experienced drivers handling routes and traffic. This service guarantees safe, punctual, and comfortable transportation for all types of local travel needs."
},
{
"name": "Group Travel Local Bus Pune",
"description": "Group Travel Local Bus Pune is perfect for transporting large groups within the city for tours, picnics, corporate programs, and social events. Spacious buses and organized travel planning ensure smooth group movement."
},
{
"name": "Best Local Bus Service Pune",
"description": "Best Local Bus Service Pune is known for reliability, punctuality, and well-maintained buses. Trusted by individuals, families, and corporates, it ensures a hassle-free local travel experience across Pune."
},
{
"name": "Pune Local Bus Booking",
"description": "Pune Local Bus Booking offers a quick and easy way to reserve buses for city travel. With flexible scheduling, multiple bus options, and instant confirmation, planning local bus travel becomes simple and convenient."
},
{
"name": "Tourist Local Bus Pune",
"description": "Tourist Local Bus Pune caters to travelers exploring Pune’s attractions and nearby city spots. Comfortable buses, knowledgeable drivers, and flexible itineraries make city sightseeing enjoyable and convenient."
},
{
"name": "Event Local Bus Hire Pune",
"description": "Event Local Bus Hire Pune provides organized transportation for exhibitions, concerts, conferences, and social gatherings. These buses ensure coordinated travel and timely arrivals for all event participants."
},
{
"name": "Family Local Bus Pune",
"description": "Family Local Bus Pune offers safe and comfortable transportation for family outings, functions, and city trips. Designed for all age groups, it ensures a smooth and enjoyable local travel experience."
},
{
"name": "City Travel Bus Pune",
"description": "City Travel Bus Pune delivers comprehensive local transportation solutions for daily commuting and special occasions. With professional drivers and comfortable buses, it simplifies travel within Pune city."
}
],
"tableData": [
["Local Bus Hire In Pune", "Local Bus Rental Pune"],
["AC Local Bus Pune", "Luxury Local Bus Rental Pune"],
["Corporate Local Bus Pune", "Wedding Local Bus Pune"],
["Affordable Local Bus Pune", "Chauffeur Driven Local Bus"],
["Group Travel Local Bus Pune", "Best Local Bus Service Pune"],
["Pune Local Bus Booking", "Tourist Local Bus Pune"],
["Event Local Bus Hire Pune", "Family Local Bus Pune"],
["City Travel Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Local Bus Hire in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable local bus hire services in Pune, ideal for city tours, family outings, school trips, corporate events, and one-day excursions."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable ride throughout Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Pune’s local routes and traffic conditions, ensuring safe, punctual, and stress-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for local bus hire in Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your local bus hire."
  },
  {
    "WhyChooseheading": "Flexible Hire Options",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized bus hire packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for local bus hire in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide local bus hire services in Pune?',
    answer: 'Yes, Sanavi Travels offers dependable and comfortable local bus hire services in Pune for various travel needs within the city and nearby.'
  },
  {
    question: 'How can I book a local bus in Pune?',
    answer: 'You can book a local bus hire through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of buses are available for local hire in Pune?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options based on your group size.'
  },
  {
    question: 'Are the drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune’s local routes to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Pune and surrounding areas.'
  },
  {
    question: 'Is the local bus hire service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock local bus hire services in Pune to suit your schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for local bus hire?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus hire bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your local bus hire trip in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patil',
    feedback: 'Booked a local bus hire in Pune with Sanavi Travels — excellent service, punctual driver, and very comfortable bus!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ananya Kulkarni',
    feedback: 'Great experience with local bus hire in Pune. Sanavi Travels took care of everything and made our trip hassle-free!',
    rating: 5
  }
];

































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Local Bus Hire In Pune - Sanavi Travels",
  "description": "Local bus hire service in Pune by Sanavi Travels for city tours, corporate travel, weddings, events, and family trips. Choose AC and luxury buses for safe, comfortable, and affordable local travel within Pune.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1500"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Local Bus Hire In Pune Starting from ₹30 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book local buses in Pune with Sanavi Travels. AC and luxury buses for city tours, corporate travel, weddings, events, and family trips at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Localbushireinpune;